(function () {
    const openButtons = document.querySelectorAll(".button-open");
    // const form = document.querySelector("form");
    // const step1 = document.getElementById("step1");
    const step2a = document.getElementById("step2a");
    const step2b = document.getElementById("step2b");
    const selectContact = document.getElementById("selectContact");
    const addFocusTrap = (e) => {
        if (e.key === "Tab") {
            e.preventDefault();
        }
    };

    const closeModal = (modal) => {
        modal.close();
        modal.removeEventListener("keydown", addFocusTrap);
    };

    const closePreviousModal = () => {
        const openModal = document.querySelector("dialog[open]");
        if (openModal) {
            closeModal(openModal);
        }
    };

    const closeModalOnOutsideClick = (event) => {
        const modalContent = event.currentTarget.querySelector(".mod__modal-content");
        if (modalContent && event.target !== modalContent && !modalContent.contains(event.target)) {
            const modal = event.currentTarget;
            closeModal(modal);
            modal.removeEventListener("click", closeModalOnOutsideClick);
        }
    };

    const goToStep = (step) => {
        closePreviousModal();
        step.showModal();

        const closeButton = step.querySelector(".button-close-modal");
        if (closeButton) {
            closeButton.focus();
        }

        step.addEventListener("keydown", addFocusTrap);
        step.addEventListener("click", closeModalOnOutsideClick);
    };

    const sendFormAndGoToStep = (step) => {
        // form.submit(); // Replace with your actual form submission code
        goToStep(step);
    };

    const handleStep1Confirmation = (event) => {
        event.preventDefault();

        const selectedValue = document.querySelector('input[name="detailsOnContact"]:checked').value;
        if (selectedValue === "yes") {
            sendFormAndGoToStep(step2a);
        } else if (selectedValue === "no") {
            sendFormAndGoToStep(step2b);
        }
    };

    if (!openButtons) return;

    openButtons.forEach((button) => {
        button.addEventListener("click", () => {
            const modal = button.parentElement.nextElementSibling;
            goToStep(modal);
        });
    });

    const closeButtons = document.querySelectorAll(".button-close-modal");

    if (!closeButtons) return;

    closeButtons.forEach((button) => {
        button.addEventListener("click", () => {
            const modal = button.closest("dialog");
            closeModal(modal);
        });
    });

    document.addEventListener("keydown", (event) => {
        if (event.key === "Escape") {
            closePreviousModal();
        }
    });

    const confirmButton = document.querySelector("#step1 .btn");
    if (confirmButton) {
        confirmButton.addEventListener("click", handleStep1Confirmation);
    }

    const openSelectContactButton = document.querySelector("#step2b #openSelectContact");
    if (openSelectContactButton) {
        openSelectContactButton.addEventListener("click", () => {
            goToStep(selectContact);
        });
    }

    // Confirm Remove Contact Person
    var postContactForms = document.querySelectorAll('form[id^="form_email_post_emergency_contact_"]');

    // Attach event listeners to each form
    postContactForms.forEach(function (form) {
        form.addEventListener("submit", function (event) {
            event.preventDefault();

            // Get the unique number from the form ID
            // var formId = form.id.split("_").pop();

            var postPersonid = form.querySelector('input[name="postPersonid"]');
            var postPersonid = postPersonid ? postPersonid.value : "";

            var postContactpersonid = form.querySelector('input[name="postContactpersonid"]');
            var postContactpersonid = postContactpersonid ? postContactpersonid.value : "";

            var postEmergencyFlag = form.querySelector('input[name="postEmergencyFlag"]');
            var postEmergencyFlag = postEmergencyFlag ? postEmergencyFlag.value : "";

            // Get the URL from the form's action attribute
            var postFormAction = form.action;
            postFormAction += "?personid=" + encodeURIComponent(postPersonid) + "&contactpersonid=" + encodeURIComponent(postContactpersonid) + "&emergencyflag=" + encodeURIComponent(postEmergencyFlag);

            // Send the form data using JavaScript
            var xhr = new XMLHttpRequest();
            xhr.open("POST", postFormAction);
            xhr.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");

            // Construct the form data
            var postFormData = new FormData();
            postFormData.append("personid", postPersonid);
            postFormData.append("contactpersonid", postContactpersonid);
            postFormData.append("emergencyflag", postEmergencyFlag);

            // Handle the response
            xhr.onreadystatechange = function () {
                if (xhr.readyState === 4 && xhr.status === 200) {
                    document.getElementById("selectContact").close();
                    document.getElementById("postContactConfirm").showModal();
                }
            };
            // Send the form data
            xhr.send(postFormData);
        });
    });
})();
